/**
 * ScriptPad brand palette.
 *
 * Colours are extracted from the live scriptpad.health Webflow stylesheet
 * (see :root variables `--primary--blue`, `--primary--yellow`, `--primary--red`,
 * `--primary--green`, `--text--navy`, `--text--dark-grey`, `--light-blue`).
 */
export const colors = {
  primary: '#3c86ec',
  primaryDark: '#1f6dd4',
  primaryLight: '#6aa3f0',
  navy: '#23355f',
  darkGrey: '#414748',
  lightGrey: '#787878',
  bgWash: '#f4f8fb',
  yellow: '#ecb527',
  green: '#37dd96',
  red: '#f4673b',
  white: '#ffffff',
  border: '#e2e8f0',
} as const;

export type ScriptPadColor = keyof typeof colors;
